import { useQuery } from "@tanstack/react-query";
import { getAlertSettings } from "../api/alertSettings";
import { useAuth } from "../auth/AuthContext";
import { AlertSettingsForm } from "../components/AlertSettingsForm";
import { DashboardDisplayForm } from "../components/DashboardDisplayForm";
import { GenieSwitchesForm } from "../components/GenieSwitchesForm";
import { LookupModelForm } from "../components/LookupModelForm";
import { ErrorBlock, LoadingBlock } from "../components/QueryStatus";

export function SettingsPage() {
  const { user } = useAuth();
  const { data, isPending, isError } = useQuery({
    queryKey: ["alert-settings"],
    queryFn: () => getAlertSettings(),
  });

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow">Alert Configuration</div>
        <h2 className="mt-1 text-lg font-semibold text-zinc-900">Alert settings</h2>
        <p className="mt-1 max-w-2xl text-sm text-zinc-500">
          What gets sent right away versus what waits for the regular digest. These preferences apply org-wide
          for everyone on the team.
        </p>
      </div>

      {isPending ? <LoadingBlock label="Loading alert settings" surface="canvas" /> : null}
      {isError ? <ErrorBlock message="Could not load alert settings." surface="canvas" /> : null}
      {data ? <AlertSettingsForm settings={data} /> : null}
      {data ? <DashboardDisplayForm settings={data} /> : null}
      {data ? <LookupModelForm settings={data} /> : null}
      {data && user?.role === "admin" ? <GenieSwitchesForm settings={data} /> : null}
    </div>
  );
}
